import React from 'react';
import { useRouteLoading } from 'app/hooks/useRouteLoading';
import './GlobalLoadingIndicator.css';

interface GlobalLoadingIndicatorProps {
  className?: string;
}

/**
 * A component that displays a global loading indicator when routes are loading
 * This can be placed in your main layout, header, or anywhere in your app
 */
export const GlobalLoadingIndicator: React.FC<GlobalLoadingIndicatorProps> = ({ className = '' }) => {
  const isLoading = useRouteLoading();
  
  if (!isLoading) {
    return null;
  }
  
  return (
    <div className={`global-loading-indicator ${className}`}>
      <div className="loading-indicator-bar"></div>
    </div>
  );
}; 